// REACT AND REACT HOOKS
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';

// BOOTSTRAP COMPONENTS for modal and buttons
import { Modal, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

//cookies
import Cookies from 'js-cookie';

//QR Code library for generating QR codes
import QRCode from 'react-qr-code';

// DATATABLES LIBRARY (not used directly here, but imported for consistency)
import DataTable from 'datatables.net-react';

// UTILITY FUNCTIONS for extracting plain item names
import { getPlainName } from '../FP_foodPantryUtils';

// TABLE COLUMN CONFIGURATIONS (not used directly here, but available for future table displays)
import { columnsInventory, columnsTransactions } from '../FP_foodPantryTables'

// ReleaseItemsModal component for releasing inventory items (scan/manual entry)
import introJs from 'intro.js';

export function ReleaseItemsModal({ show, onHide, selectedOrgID, showReceiveItemSuccessBanner, foodPantryTourStager, setFoodPantryTourStager }) {


  // Controls which section is visible
  const [showIdentifyForm, setShowIdentifyForm] = useState(true); // Identification method selection
  const [manualIdentifyForm, setManualIdentifyForm] = useState(false); // Manual search for user
  const [showReleaseForm, setShowReleaseForm] = useState(false); // Release items section
  const [manualReleaseForm, setManualReleaseForm] = useState(false); // Manual add item (vs scan)


  const [FakeIdentifyForm, setFakeIdentifyForm] = useState(false); // FAKE manual search for user
  const [fakeUserSearch, setFakeUserSearch] = useState("");



  // Lists fetched from backend for suggestions and validation
  const [allItems, setAllItems] = useState([])
  const [allVariations, setAllVariations] = useState([])
  const [transactions, setTransactions] = useState([])

  // Preview list and suggestions for autocomplete
  const [addedItems, setAddedItems] = useState([])
  const [itemSuggestions, setItemSuggestions] = useState([])
  const [variationSuggestions, setVariationSuggestions] = useState([])

  // Form input states
  const [itemNameInput, setItemNameInput] = useState("")
  const [variationNameInput, setVariationNameInput] = useState("")
  const [quantityInput, setQuantityInput] = useState(1)
  const [upcInput, setUpcInput] = useState("")
  const [upcValue, setUpcValue] = useState("")
  const [editIndex, setEditIndex] = useState(null)
  const [selectedUser, setSelectedUser] = useState(null)
  const [userSearch, setUserSearch] = useState("")
  const [userScanCode, setUserScanCode] = useState("")
  const [transactionType, setTransactionType] = useState("DISTRIBUTION");
  const [distributionID, setDistributionID] = useState(null);

  // user search results data
  const [userSearchResults, setUserSearchResults] = useState([])
  const [userPage, setUserPage] = useState(0);

  // Helper to reset all state to initial (call on modal close)
  const resetAllStates = () => {
    setShowIdentifyForm(true);
    setManualIdentifyForm(false);
    setShowReleaseForm(false);
    setManualReleaseForm(false);
    setAddedItems([]);
    setItemNameInput("");
    setVariationNameInput("");
    setQuantityInput(1);
    setCodeInput("");
    setScanCode("");
    setEditIndex(null);
  };

  // Unified code input and scan/manual mode
  const [codeInput, setCodeInput] = useState("");
  const [scanCode, setScanCode] = useState("");
  const codeInputRef = useRef(null);

  //QR Code value
  const [qrValue, setQrValue] = useState(Cookies.get('userID'));
  const [showQrScanner, setShowQrScanner] = useState(false);

  // const handleOpenCamera = () => {
  //   // Placeholder for camera functionality
  //   alert("Camera functionality is not implemented in this demo.");
  // }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch all items, variations, and transactions, and clients when modal opens
  useEffect(() => {
    if (show) {
      const url = process.env.REACT_APP_BACKURL;
      fetch(url + '/api/foodPantry/inventory/' + selectedOrgID + '/items', {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
      })
        .then(res => res.json())
        .then(data => setAllItems(Array.isArray(data) ? data : []))
        .catch(() => setAllItems([]));

      fetch(url + '/api/foodPantry/inventory/' + selectedOrgID + '/all-variations', {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
      })
        .then(res => res.json())
        .then(data => setAllVariations(Array.isArray(data) ? data : []))
        .catch(() => setAllVariations([]));

      fetch(url + `/api/foodPantry/inventory/${selectedOrgID}/transactions`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
      })
        .then(res => res.json())
        .then(data => setTransactions(Array.isArray(data) ? data : []))
        .catch(() => setTransactions([]));


      fetch(url + '/api/foodPantry/client/list', {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET'
      })
        .then(res => res.json())
        .then(data => setUserSearchResults(Array.isArray(data.clients) ? data.clients : []))
        .catch(() => setUserSearchResults([]));

    }
    if (!show) {
      resetAllStates();
    }
  }, [show, selectedOrgID]);

  // Focus code input when scan mode is active
  const searchInputRef = useRef(null);
  const itemNameInputRef = useRef(null);


  useEffect(() => {
    if (!manualReleaseForm && show && codeInputRef.current) {
      codeInputRef.current.focus();
    }
  }, [manualReleaseForm, show]);

  useEffect(() => {
    if (showIdentifyForm && manualIdentifyForm && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [showIdentifyForm, manualIdentifyForm]);

  useEffect(() => {
    if (showReleaseForm && !manualReleaseForm && codeInputRef.current) {
      codeInputRef.current.focus();
    }
  }, [showReleaseForm, manualReleaseForm]);

  useEffect(() => {
    if (manualReleaseForm && showReleaseForm && itemNameInputRef.current) {
      itemNameInputRef.current.focus();
    }
  }, [manualReleaseForm, showReleaseForm]);


  // Suggest items as user types
  const handleItemNameChange = (e) => {
    const value = e.target.value
    setItemNameInput(value)
    if (value.length > 0) {
      setItemSuggestions(
        allItems.filter(item =>
          item.name.toLowerCase().includes(value.toLowerCase())
        ).slice(0, 5)
      )
    } else {
      setItemSuggestions([])
    }
    setVariationNameInput("")
    setVariationSuggestions([])
  }

  // Suggest variations as user types
  const handleVariationNameChange = (e) => {
    const value = e.target.value
    setVariationNameInput(value)
    const selectedItem = allItems.find(
      item => item.name.toLowerCase() === itemNameInput.toLowerCase()
    )
    let filteredVariations = allVariations
    if (selectedItem) {
      filteredVariations = allVariations.filter(
        variation => variation.itemID === selectedItem.itemID
      )
    }
    if (value.length > 0) {
      setVariationSuggestions(
        filteredVariations.filter(variation =>
          variation.name.toLowerCase().includes(value.toLowerCase())
        ).slice(0, 5)
      )
    } else {
      setVariationSuggestions([])
    }
  }

  // Helper for code type inference
  const inferCodeType = (code) => {
    if (!code) return "Other";
    if (code.length === 12) return "UPC";
    if (code.length === 4) return "PLU";
    if (code.length === 5) return "Other";
    return "Other";
  };

  // Scan input logic
  // Scan input logic: only submit on Enter, limit to 12 digits
  const handleScan = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 12);
    setScanCode(value);
  };

  const handleScanKeyDown = (e) => {
    if (e.key === "Enter" && scanCode.length > 0) {
      handleCodeScan(scanCode);
      setScanCode("");
      e.preventDefault();
    }
  };

  // Unified code scan handler
  // Unified code scan handler: just search for any matching code
  const handleCodeScan = async (value) => {
    let variation = allVariations.find(v => v.upc === value || v.plu === value || v.otherCode === value);
    if (!variation) {
      showReceiveItemSuccessBanner(
        "Code Not Found",
        <span>Code not found. Please check or create the variation first.</span>,
        "extreme-error"
      );
      return;
    }
    const item = allItems.find(i => i.itemID === variation.itemID);
    if (!item) {
      showReceiveItemSuccessBanner(
        "Item Not Found",
        <span>No item found for this variation.</span>,
        "extreme-error"
      );
      return;
    }
    const totalAvailable = transactions
      .filter(t => t.itemVariationID === variation.itemVariationID)
      .reduce((sum, t) => sum + (parseInt(t.transactionQty, 10) || 0), 0);
    if (totalAvailable < 1) {
      showReceiveItemSuccessBanner(
        "No Quantity",
        <span>No available quantity for this item/variation.</span>,
        "alert"
      );
      return;
    }
    await addItemToPreview({ item, variation, quantity: 1, upc: value });
  };

  // Add item to preview list (manual or scan)
  const addItemToPreview = async ({ item, variation, quantity, upc }) => {
    const totalAvailable = transactions
      .filter(t => t.itemVariationID === variation.itemVariationID)
      .reduce((sum, t) => sum + (parseInt(t.transactionQty, 10) || 0), 0)

    if (quantity > totalAvailable) {
      showReceiveItemSuccessBanner(
        "Quantity Exceeded",
        <span>Cannot release more than available quantity ({totalAvailable})</span>,
        "alert"
      );
      return;
    }

    if (editIndex !== null) {
      const updated = [...addedItems]
      updated[editIndex] = {
        itemName: item.name,
        variationName: variation.name,
        quantity,
        unitQty: item.unitQty,
        packSize: item.packSize,
        category: item.category,
        itemID: item.itemID,
        itemVariationID: variation.itemVariationID,
        upc: upc || variation.upc || "",
        totalAvailable
      }
      setAddedItems(updated)
      setEditIndex(null)
    } else {
      const existingIdx = addedItems.findIndex(
        i =>
          i.itemID === item.itemID &&
          i.itemVariationID === variation.itemVariationID &&
          i.variationName === variation.name
      )
      if (existingIdx !== -1) {
        const updated = [...addedItems]
        updated[existingIdx].quantity =
          parseInt(updated[existingIdx].quantity, 10) + parseInt(quantity, 10)
        setAddedItems(updated)
      } else {
        setAddedItems(prev => [
          ...prev,
          {
            itemName: item.name,
            variationName: variation.name,
            quantity,
            unitQty: item.unitQty,
            packSize: item.packSize,
            category: item.category,
            itemID: item.itemID,
            itemVariationID: variation.itemVariationID,
            upc: upc || variation.upc || "",
            totalAvailable,
          }
        ])
      }
    }
    setItemNameInput("")
    setVariationNameInput("")
    setQuantityInput(1)
    setUpcInput("")
    setUpcValue("")
  }

  // Handle UPC scan input (scan mode)
  const handleUpcScan = async (value) => {
    setUpcValue(value)
    if (value.length === 12) {
      const variation = allVariations.find(v => v.upc === value)
      if (!variation) {
        showReceiveItemSuccessBanner(
          "UPC Not Found",
          <span>UPC not found. Please check the UPC or create the variation first.</span>,
          "extreme-error"
        );
        return;
      }
      const item = allItems.find(i => i.itemID === variation.itemID)
      if (!item) {
        showReceiveItemSuccessBanner(
          "Item Not Found",
          <span>No item found for this variation.</span>,
          "extreme-error"
        );
        return;
      }
      const totalAvailable = transactions
        .filter(t => t.itemVariationID === variation.itemVariationID)
        .reduce((sum, t) => sum + (parseInt(t.transactionQty, 10) || 0), 0)

      if (totalAvailable < 1) {
        showReceiveItemSuccessBanner(
          "No Quantity",
          <span>No available quantity for this item/variation.</span>,
          "alert"
        );
        return;
      }

      await addItemToPreview({ item, variation, quantity: 1, upc: value })
    }
  }

  // Handle user selection from search results
  const handleUserSelect = (user) => {
    // Set the entire user object, not just the name
    setSelectedUser(user);

    // Hide identify form, show release form, default to scan mode
    setShowIdentifyForm(false);
    setShowReleaseForm(true);
    setManualReleaseForm(false);
  };

  function formatPhone(phone) {
    // Only format if 10 digits
    const cleaned = ('' + phone).replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  }

  /*
  // Add these handlers after handleUpcScan:
  const handlePluScan = async (value) => {
    setPluValue(value);
    if (value.length === 4) {
      const variation = allVariations.find(v => v.plu === value);
      if (!variation) {
        showReceiveItemSuccessBanner(
          "PLU Not Found",
          <span>PLU not found. Please check the PLU or create the variation first.</span>,
          "extreme-error"
        );
        return;
      }
      const item = allItems.find(i => i.itemID === variation.itemID);
      if (!item) {
        showReceiveItemSuccessBanner(
          "Item Not Found",
          <span>No item found for this variation.</span>,
          "extreme-error"
        );
        return;
      }
      const totalAvailable = transactions
        .filter(t => t.itemVariationID === variation.itemVariationID)
        .reduce((sum, t) => sum + (parseInt(t.transactionQty, 10) || 0), 0);
   
      if (totalAvailable < 1) {
        showReceiveItemSuccessBanner(
          "No Quantity",
          <span>No available quantity for this item/variation.</span>,
          "alert"
        );
        return;
      }
   
      await addItemToPreview({ item, variation, quantity: 1, upc: value });
    }
  };
  */

  /*
    const handleOtherCodeScan = async (value) => {
      setOtherCodeValue(value);
      if (value.length === 5) {
        const variation = allVariations.find(v => v.otherCode === value);
        if (!variation) {
          showReceiveItemSuccessBanner(
            "ID Not Found",
            <span>Unique ID not found. Please check the ID or create the variation first.</span>,
            "extreme-error"
          );
          return;
        }
        const item = allItems.find(i => i.itemID === variation.itemID);
        if (!item) {
          showReceiveItemSuccessBanner(
            "Item Not Found",
            <span>No item found for this variation.</span>,
            "extreme-error"
          );
          return;
        }
        const totalAvailable = transactions
          .filter(t => t.itemVariationID === variation.itemVariationID)
          .reduce((sum, t) => sum + (parseInt(t.transactionQty, 10) || 0), 0);
   
        if (totalAvailable < 1) {
          showReceiveItemSuccessBanner(
            "No Quantity",
            <span>No available quantity for this item/variation.</span>,
            "alert"
          );
          return;
        }
   
        await addItemToPreview({ item, variation, quantity: 1, upc: value });
      }
    };
  */

  // Remove item from preview list
  const removeItem = (idx) => {
    setAddedItems(prev => prev.filter((_, i) => i !== idx))
  }

  // Edit item in preview list
  const editItem = (idx) => {
    const item = addedItems[idx];
    setItemNameInput(item.itemName);
    setVariationNameInput(item.variationName);
    setQuantityInput(item.quantity);
    setCodeInput(item.upc);
    setEditIndex(idx);
    setManualReleaseForm(true);
    setShowReleaseForm(true);
    setShowIdentifyForm(false);
  };

  // Manual form submit handler
  const handleManualSubmit = async (e) => {
    e.preventDefault();
    const codeToUse = codeInput.replace(/\D/g, "");
    let item = null;
    let variation = null;
    let codeField = codeToUse;
    const codeType = inferCodeType(codeToUse);
    if (codeToUse && (codeType === "UPC" || codeType === "PLU" || codeType === "Other")) {
      if (codeType === "UPC") variation = allVariations.find(v => v.upc === codeToUse);
      else if (codeType === "PLU") variation = allVariations.find(v => v.plu === codeToUse);
      else if (codeType === "Other") variation = allVariations.find(v => v.otherCode === codeToUse);
      if (!variation) {
        showReceiveItemSuccessBanner(
          "Code Not Found",
          <span>Code not found. Please use the Create modal first.</span>,
          "extreme-error"
        );
        return;
      }
      item = allItems.find(i => i.itemID === variation.itemID);
      if (!item) {
        showReceiveItemSuccessBanner(
          "Item Not Found",
          <span>No item found for this variation.</span>,
          "extreme-error"
        );
        return;
      }
      setItemNameInput(item.name);
      setVariationNameInput(variation.name);
    } else if (itemNameInput && variationNameInput) {
      item = allItems.find(i => i.name === itemNameInput);
      if (!item) {
        showReceiveItemSuccessBanner(
          "Item Not Found",
          <span>Item does not exist. Please use the Create modal first.</span>,
          "alert"
        );
        return;
      }
      variation = allVariations.find(
        v => v.name === variationNameInput && v.itemID === item.itemID
      );
      if (!variation) {
        showReceiveItemSuccessBanner(
          "Variation Not Found",
          <span>Variation does not exist. Please use the Create modal first.</span>,
          "alert"
        );
        return;
      }
      // Auto-fill code based on available code type
      if (!codeToUse) {
        if (variation.upc) {
          codeField = variation.upc;
          setCodeInput(variation.upc);
        } else if (variation.plu) {
          codeField = variation.plu;
          setCodeInput(variation.plu);
        } else if (variation.otherCode) {
          codeField = variation.otherCode;
          setCodeInput(variation.otherCode);
        } else {
          showReceiveItemSuccessBanner(
            "No Code Available",
            <span>No available code tied to this variation.</span>,
            "alert"
          );
          return;
        }
      }
    } else {
      showReceiveItemSuccessBanner(
        "Missing Info",
        <span>Please provide either a valid code or both Item Name and Variation Name.</span>,
        "alert"
      );
      return;
    }
    const qty = parseInt(quantityInput, 10);
    if (!qty || qty < 1) {
      showReceiveItemSuccessBanner(
        "Invalid Quantity",
        <span>Enter a valid quantity.</span>,
        "alert"
      );
      return;
    }
    await addItemToPreview({ item, variation, quantity: qty, upc: codeField });
    setCodeInput("");
  }
  let tempVisitID = null;
  let tempDistributionID = null;

  // Record visit before outtake
  const recordVisit = async () => {
    const url = process.env.REACT_APP_BACKURL;
    // Sum the absolute value of quantity for all addedItems
    const totalReleased = addedItems.reduce((sum, item) => sum + Math.abs(Number(item.quantity)), 0);
    try {
      const response = await fetch(url + '/api/foodPantry/visit', {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          visit: {
            userID: selectedUser.userID,
            date: new Date().toISOString().split('T')[0],
            reason: "Food pantry visit",
            notes: `Total items received: ${totalReleased}`
          },
          service: {
            orgID: selectedOrgID,
            serviceType: "Food pantry"
          },
        })
      });
      const result = await response.json();
      tempVisitID = result.visitID;
      return result;
    } catch (err) {
      showReceiveItemSuccessBanner(
        "Visit Error",
        <span>Failed to record visit: {err.message}</span>,
        "alert"
      );
    }
  };

  const recordDistribution = async () => {
    const url = process.env.REACT_APP_BACKURL;
    // Sum the absolute value of quantity for all addedItems
    const totalReleased = addedItems.reduce((sum, item) => sum + Math.abs(Number(item.quantity)), 0);
    try {
      const response = await fetch(url + `/api/foodPantry/distribution/${selectedOrgID}`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          distribution: {
            userID: selectedUser.userID,
            visitID: tempVisitID, // Will be set after visit is recorded
          }
        })
      });
      const result = await response.json();
      tempDistributionID = result.distributionID;
      return result;
    } catch (err) {
      showReceiveItemSuccessBanner(
        "Visit Error",
        <span>Failed to record visit: {err.message}</span>,
        "alert"
      );
    }
  };

  // Finalize: POST all releases to backend and show notification banner
  const finalizeRelease = async () => {
    const url = process.env.REACT_APP_BACKURL;
    try {
      await recordVisit();
      await recordDistribution();
      for (const item of addedItems) {
        const res = await fetch(
          url + `/api/foodPantry/inventory/${selectedOrgID}/outtake-inventory-item`,
          {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify({
              inventory: {
                itemVariationID: item.itemVariationID,
                quantity: -Math.abs(item.quantity),
                expirationDate: new Date().toISOString().split('T')[0],
                transactionDate: new Date().toISOString().split('T')[0],
                orgID: selectedOrgID,
                userID: selectedUser.userID,
                transactionType: transactionType,
              },
              distribution: {
                distributionID: tempDistributionID || null
              }
            })
          }
        );
        const result = await res.json();
        if (!res.ok) {
          throw new Error(result.message || "Failed to release item");
        }
      }
      setAddedItems([]);
      onHide();

      showReceiveItemSuccessBanner(
        "Success",
        (() => {
          const maxNames = 3;
          const names = addedItems.map(i => i.variationName);
          const count = addedItems.length;
          const plural = count === 1 ? "item" : "items";
          if (names.length > maxNames) {
            return (
              <span>
                <strong>{count} {plural} released:</strong> {names.slice(0, maxNames).join(", ")}, and {names.length - maxNames} others.
              </span>
            );
          }
          return (
            <span>
              <strong>{count} {plural} released:</strong> {names.join(", ")}
            </span>
          );
        })(),
        "success"
      );
    } catch (err) {
      showReceiveItemSuccessBanner(
        "Critical Error",
        <span>Failed to finalize release: {err.message}</span>,
        "extreme-error"
      );
    }
  }


  // --- TOUR LOGIC ---
  useEffect(() => {
    if (show && foodPantryTourStager === "Release Modal") {
      // Start with QR code, then code input, then manual search button
      const steps = [
        {
          element: '#qr-card',
          intro: "This is the current user's Identifying QR code. you must tie a user to a release transaction to release.",
          hidePrev: true
        },
        {
          element: '[aria-label="Scan or enter code here"]',
          intro: "Scan the QR code and put the input here ot automatically tie that user to this release",
          hidePrev: true
        },
        {
          element: '.manual-entry-hover',
          intro: "if you cannot get their qr code you can manually search them up with this button",
          hidePrev: true
        }
      ];

      // Prevent starting a new tour if one is already running
      // if (document.querySelector('.introjs-overlay')) return;
      const intro = introJs();
      intro.setOptions({
        steps,
        showBullets: false,
        exitOnOverlayClick: false
      });
      intro.onbeforechange(function () {
        setTimeout(() => {
          const prevBtn = document.querySelector('.introjs-prevbutton');
          if (prevBtn) prevBtn.style.display = 'none';
          const nextBtn = document.querySelector('.introjs-nextbutton');
          if (nextBtn) nextBtn.textContent = 'Next';
          const doneBtn = document.querySelector('.introjs-donebutton');
          if (doneBtn) doneBtn.textContent = 'Next';
        }, 0);
      });

      intro.oncomplete(() => {
        // After the last step, switch to fake manual search and start a new tour
        setFakeIdentifyForm(true);
        setTimeout(() => {
          // Step 1: highlight empty search field
          setFakeUserSearch("");
          setTimeout(() => {
            // if (document.querySelector('.introjs-overlay')) return;
            const manualIntro1 = introJs();
            manualIntro1.setOptions({
              steps: [
                {
                  element: '#fake-user-search-input',
                  intro: "start typing in this field to serach a user by their name, phone number, and email",
                  hidePrev: true
                }
              ],
              showBullets: false,
              exitOnOverlayClick: false
            });
            manualIntro1.onbeforechange(function () {
              setTimeout(() => {
                const prevBtn = document.querySelector('.introjs-prevbutton');
                if (prevBtn) prevBtn.style.display = 'none';
                const nextBtn = document.querySelector('.introjs-nextbutton');
                if (nextBtn) nextBtn.textContent = 'Next';
                const doneBtn = document.querySelector('.introjs-donebutton');
                if (doneBtn) doneBtn.textContent = 'Next';
              }, 0);
            });
            manualIntro1.oncomplete(() => {
              // Step 2: highlight field with 'John' entered
              setFakeUserSearch("John");
              setTimeout(() => {
                // if (document.querySelector('.introjs-overlay')) return;
                const manualIntro2 = introJs();
                manualIntro2.setOptions({
                  steps: [
                    {
                      element: '#fake-user-search-input',
                      intro: "For example lets look for John Smith.",
                      hidePrev: true
                    },
                    {
                      element: '#fake-user-result-0',
                      intro: "Once he apperars click on them to assing them to the release transaction",
                      hidePrev: true
                    }
                  ],
                  showBullets: false,
                  exitOnOverlayClick: false
                });
                manualIntro2.onbeforechange(function () {
                  setTimeout(() => {
                    const prevBtn = document.querySelector('.introjs-prevbutton');
                    if (prevBtn) prevBtn.style.display = 'none';
                    const nextBtn = document.querySelector('.introjs-nextbutton');
                    if (nextBtn) nextBtn.textContent = 'Next';
                    const doneBtn = document.querySelector('.introjs-donebutton');
                    if (doneBtn) doneBtn.textContent = 'Next';
                  }, 0);
                });
                manualIntro2.oncomplete(() => {
                  // After highlighting the first result, select the user and go to release form
                  const fakeUser = {
                    userID: "john-1",
                    firstName: "John",
                    lastName: "Smith",
                    phoneNumber: "5551112222",
                    DOB: "1990-01-01"
                  };
                  handleUserSelect(fakeUser);
                  setFakeIdentifyForm(false);
                  setTimeout(() => {
                    // if (document.querySelector('.introjs-overlay')) return;
                    const releaseIntro = introJs();
                    releaseIntro.setOptions({
                      steps: [
                        {
                          element: '#release-user-btn',
                          intro: "This show what current user is tied to the release transaction.",
                          hidePrev: true
                        },
                        {
                          element: '#release-code-input',
                          intro: "Here is where you can enter an item to release based off of its UPC code if it's already in the system. It also accepts PLU or Alt-ID.",
                          hidePrev: true
                        },
                        {
                          element: '#add-manually-btn',
                          intro: "An item can also be added in manually by clicking this button.",
                          hidePrev: true
                        }
                      ],
                      showBullets: false,
                      exitOnOverlayClick: false
                    });
                    releaseIntro.onbeforechange(function () {
                      setTimeout(() => {
                        const prevBtn = document.querySelector('.introjs-prevbutton');
                        if (prevBtn) prevBtn.style.display = 'none';
                        const nextBtn = document.querySelector('.introjs-nextbutton');
                        if (nextBtn) nextBtn.textContent = 'Next';
                        const doneBtn = document.querySelector('.introjs-donebutton');
                        if (doneBtn) doneBtn.textContent = 'Next';
                      }, 0);
                    });
                    releaseIntro.oncomplete(() => {
                      // After highlighting the add manually button, switch to manual form and highlight the group of 4 fields
                      setManualReleaseForm(true);
                      setTimeout(() => {
                        // if (document.querySelector('.introjs-overlay')) return;
                        const manualFormIntro = introJs();
                        manualFormIntro.setOptions({
                          steps: [
                            {
                              element: '#manual-form-fields',
                              intro: "Here simply enter the information about the item, either its name and variation or just the UPC/PLU/Alt-ID or all of it. Once you are done click the add button",
                              hidePrev: true
                            }
                          ],
                          showBullets: false,
                          exitOnOverlayClick: false
                        });
                        manualFormIntro.onbeforechange(function () {
                          setTimeout(() => {
                            const prevBtn = document.querySelector('.introjs-prevbutton');
                            if (prevBtn) prevBtn.style.display = 'none';
                            const nextBtn = document.querySelector('.introjs-nextbutton');
                            if (nextBtn) nextBtn.textContent = 'Next';
                            const doneBtn = document.querySelector('.introjs-donebutton');
                            if (doneBtn) doneBtn.textContent = 'Next';
                          }, 0);
                        });
                        manualFormIntro.oncomplete(() => {
                          // Highlight the empty preview table first
                          setTimeout(() => {
                            // if (document.querySelector('.introjs-overlay')) return;
                            const emptyPreviewIntro = introJs();
                            emptyPreviewIntro.setOptions({
                              steps: [
                                {
                                  element: '#preview-table',
                                  intro: "Once you add an item, it will appear in this preview table. Let's see what it would look like.",
                                  hidePrev: true
                                }
                              ],
                              showBullets: false,
                              exitOnOverlayClick: false
                            });
                            emptyPreviewIntro.onbeforechange(function () {
                              setTimeout(() => {
                                const prevBtn = document.querySelector('.introjs-prevbutton');
                                if (prevBtn) prevBtn.style.display = 'none';
                                const nextBtn = document.querySelector('.introjs-nextbutton');
                                if (nextBtn) nextBtn.textContent = 'Next';
                                const doneBtn = document.querySelector('.introjs-donebutton');
                                if (doneBtn) doneBtn.textContent = 'Next';
                              }, 0);
                            });
                            emptyPreviewIntro.oncomplete(() => {
                              // Add a fake item to the preview list
                              setAddedItems(prev => [
                                ...prev,
                                {
                                  itemName: 'Sample Item',
                                  variationName: 'Sample Variation',
                                  quantity: 1,
                                  upc: '123456789012',
                                  unitQty: 'unit',
                                  totalAvailable: 10
                                }
                              ]);
                              setTimeout(() => {
                                // if (document.querySelector('.introjs-overlay')) return;
                                const previewIntro = introJs();
                                previewIntro.setOptions({
                                  steps: [
                                    {
                                      element: '#preview-item-0',
                                      intro: "Before Finalizing the inventory you are about to release you can edit individual item's quantity and the price per quantity.",
                                      hidePrev: true
                                    },
                                    {
                                      element: '#transactionType',
                                      intro: "Before Finalizing be sure to select a transaction type from the dropdown list.",
                                      hidePrev: true
                                    },
                                    {
                                      element: '#finalize-btn',
                                      intro: "Click here to finalize releasing the items from inventory.",
                                      hidePrev: true
                                    }
                                  ],
                                  showBullets: false,
                                  exitOnOverlayClick: false
                                });
                                previewIntro.onbeforechange(function () {
                                  setTimeout(() => {
                                    const prevBtn = document.querySelector('.introjs-prevbutton');
                                    if (prevBtn) prevBtn.style.display = 'none';
                                    const nextBtn = document.querySelector('.introjs-nextbutton');
                                    if (nextBtn) nextBtn.textContent = 'Next';
                                    const doneBtn = document.querySelector('.introjs-donebutton');
                                    if (doneBtn) doneBtn.textContent = 'Next';
                                  }, 0);
                                });
                                previewIntro.oncomplete(() => {
                                  // Clean up: set stager, close modal, reset fake state
                                  setFoodPantryTourStager && setFoodPantryTourStager("Create Intro");
                                  onHide && onHide();
                                  setFakeIdentifyForm(false);
                                  setFakeUserSearch("");
                                  setAddedItems([]);
                                  setManualReleaseForm(false);
                                  setShowReleaseForm(false);
                                  setShowIdentifyForm(true);
                                  setManualIdentifyForm(false);
                                  setSelectedUser(null);
                                });
                                previewIntro.start();
                              }, 350);
                            });
                            emptyPreviewIntro.start();
                          }, 350);
                        });
                        manualFormIntro.start();
                      }, 350);
                    });
                    releaseIntro.start();
                  }, 350);
                });
                manualIntro2.start();
              }, 350);
            });
            manualIntro1.start();
          }, 350);
        }, 350);
      });
      setTimeout(() => {
        intro.start();
      }, 350);
    }
  }, [show, foodPantryTourStager, setManualIdentifyForm, setFoodPantryTourStager, setFakeIdentifyForm, setFakeUserSearch, setManualReleaseForm]);


  // Render modal UI
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="release-items-modal"
      centered
      dialogClassName="min-size-modal"
    >
      <div className="text-dark">
        {/* Modal header with title and close button */}
        <Modal.Header>
          <div className="d-flex justify-content-center w-100 position-relative">
            {/* Back button in its own row, top-left */}
            {(showIdentifyForm && manualIdentifyForm) && (
              <Button
                variant="light"
                onClick={() => setManualIdentifyForm(false)}
                className="position-absolute top-0 start-0 ms-2 mt-2"
                style={{ zIndex: 2 }}
                aria-label="Back"
              >
                <i className="fa fa-arrow-left"></i>
              </Button>
            )}
            <Modal.Title id="release-items-modal">Release Items</Modal.Title>
            {/* <button
              onClick={() => setFakeIdentifyForm(!FakeIdentifyForm)}
            >
              Switch to Manual Search
            </button> */}
            <Button
              variant="light"
              onClick={onHide}
              className="position-absolute top-0 end-0"
            >
              <i className="fa fa-times"></i>
            </Button>
          </div>
        </Modal.Header>

        {FakeIdentifyForm ? (
          <Modal.Body>
            <div className="d-flex flex-column align-items-center mt-4">
              <div className="d-flex mb-3 align-items-center" style={{ maxWidth: 400, width: "100%" }}>
                <form className="flex-grow-1">
                  <input
                    id="fake-user-search-input"
                    type="search"
                    placeholder="Start Typing to Search by Name or Phone..."
                    aria-label="Search"
                    value={fakeUserSearch || ""}
                    onChange={e => setFakeUserSearch(e.target.value)}
                    className="form-control"
                  />
                </form>
              </div>
              {/* Hardcoded search results if input present */}
              {fakeUserSearch && fakeUserSearch.trim().length > 0 ? (
                <div className='flex-column'
                  style={{
                    maxWidth: 400,
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                  <ul className="list-group flex-grow-1" style={{ maxWidth: 400, width: "100%" }}>
                    {[
                      { userID: "john-1", firstName: "John", lastName: "Smith", phoneNumber: "5551112222", DOB: "1990-01-01" },
                      { userID: "john-2", firstName: "John", lastName: "Johnson", phoneNumber: "5552223333", DOB: "1985-02-02" },
                      { userID: "john-3", firstName: "John", lastName: "Williams", phoneNumber: "5553334444", DOB: "1978-03-03" },
                      { userID: "john-4", firstName: "John", lastName: "Brown", phoneNumber: "5554445555", DOB: "2000-04-04" },
                      { userID: "john-5", firstName: "John", lastName: "Davis", phoneNumber: "5555556666", DOB: "1995-05-05" },
                      { userID: "john-6", firstName: "John", lastName: "Miller", phoneNumber: "5556667777", DOB: "1992-06-06" },
                      { userID: "john-7", firstName: "John", lastName: "Wilson", phoneNumber: "5557778888", DOB: "1988-07-07" },
                      { userID: "john-8", firstName: "John", lastName: "Moore", phoneNumber: "5558889999", DOB: "1999-08-08" }
                    ].map((user, idx) => (
                      <li
                        key={user.userID}
                        id={`fake-user-result-${idx}`}
                        className="list-group-item"
                        style={{ cursor: "not-allowed", opacity: 0.7 }}
                      >
                        <strong>
                          {user.firstName} {user.lastName}
                        </strong>
                        &nbsp;
                        <span className='opacity-50'>
                          ({user.phoneNumber.substring(0, 3)}) {user.phoneNumber.substring(3, 6)}-{user.phoneNumber.substring(6)}
                        </span>
                        <br />
                        Date of Birth: {new Date(user.DOB).toLocaleDateString()}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className='flex-column'
                  style={{
                    maxWidth: 400,
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                  <ul className="list-group flex-grow-1" style={{ maxWidth: 400, width: "100%" }}>
                    {[...Array(8)].map((_, idx) => (
                      <li
                        key={`empty-${idx}`}
                        className="list-group-item"
                        style={{ height: 64.64 + 5.785, background: "transparent", border: "transparent" }}
                      >
                        {/* Empty placeholder */}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </Modal.Body>
        ) : (
          <>
            {showIdentifyForm && !manualIdentifyForm && (
              <Modal.Body>
                <div
                  className={
                    windowWidth < 1000
                      ? "d-flex flex-column align-items-center justify-content-center w-100"
                      : "d-flex flex-row align-items-center justify-content-center w-100"
                  }
                  style={{ minHeight: 350 }}
                >
                  {/* Main QR Code Card */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h5 className="text-center mb-3">QR Code</h5>
                    <div
                      style={{
                        backgroundColor: "white",
                        padding: "30px 20px",
                        borderRadius: "14px",
                        border: "1px solid #ced4da",
                        width: "100%",
                        width: "240px",
                        minHeight: "240px",
                        minWidth: "160px",
                        background: "#f8f9fa",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative" // Add for absolute positioning of camera button
                      }}
                      className="position-relative"
                      id="qr-card"
                    >
                      {/* Camera button in top right of QR card 
                <button
                  type="button"
                  className="btn camera-btn position-absolute"
                  style={{
                    top: 12,
                    right: 12,
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    zIndex: 2,
                    padding: 0,
                    border: "1px solid #ced4da",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "white",
                    transition: "background 0.2s, border-color 0.2s, box-shadow 0.2s"
                  }}
                  tabIndex={-1}
                  aria-label="Open Camera"
                  onClick={handleOpenCamera}
                >
                  <i className="bi bi-camera fs-5"></i>
                </button>*/}
                      <QRCode value={qrValue || "No QR Code Generated"} viewBox="0 0 256 256" size={172} />
                    </div>
                    <div className="text-muted mt-3" style={{ fontSize: "0.95em" }}>
                      Let client scan to receive items
                    </div>
                  </div>

                  {/* Divider with OR - match QR card height */}
                  <div
                    className="d-flex flex-column align-items-center mx-5"
                    style={{
                      // height: "340px", // Match minHeight of QR card
                      justifyContent: "center"
                    }}
                  >
                    <div style={{
                      background: "#fff",
                      border: "1px solid #ced4da",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "8px 0"
                    }}>
                      <span style={{ fontWeight: "550", fontSize: "1.1em" }}>or</span>
                    </div>
                  </div>

                  {/* Manual Entry Card (smaller) */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h5 className="text-center mb-3">Search</h5>
                    <div
                      style={{
                        padding: "18px 10px",
                        borderRadius: "10px",
                        border: "1px solid #ced4da",
                        width: "180px",
                        minHeight: "240px",
                        minWidth: "240px",
                        background: "#f8f9fa",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => setManualIdentifyForm(true)}
                      className="manual-entry-hover"
                    >
                      <i className="bi bi-search mb-2 text-primary" style={{ fontSize: '5em' }}></i>
                      <div className="text-muted text-center" style={{ fontSize: "0.9em" }}>
                      </div>
                    </div>
                    <div className="text-muted mt-3" style={{ fontSize: "0.95em" }}>
                      Search by name or phone
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-4" style={{ maxWidth: 400, margin: "0 auto" }}>
                  {!manualReleaseForm && (
                    <Form.Control
                      type="password"
                      placeholder="Scan or enter code here"
                      value={userScanCode}
                      onChange={e => setUserScanCode(e.target.value)}
                      onKeyDown={e => {
                        if (e.key === "Enter" && userScanCode.trim()) {
                          const user = userSearchResults.find(user => user.userID === userScanCode);
                          if (!user) {
                            // Show toast notification banner
                            showReceiveItemSuccessBanner(
                              "User Not Found",
                              <span>User not found. Please check the ID or register the user first.</span>,
                              "extreme-error"
                            );
                            return;
                          }
                          setSelectedUser(user);

                          // Hide identify form, show release form, default to scan mode
                          setShowIdentifyForm(false);
                          setShowReleaseForm(true);
                          setManualReleaseForm(false);
                          setUserScanCode("");
                          e.preventDefault();
                        }
                      }}
                      ref={codeInputRef}
                      style={{ padding: "10px", fontSize: "1.1em" }}
                      aria-label="Scan or enter code here"
                    />
                  )}

                </div>
              </Modal.Body>
            )}

            {showIdentifyForm && manualIdentifyForm && (
              <Modal.Body>
                <div className="d-flex flex-column align-items-center mt-4">
                  <div className="d-flex mb-3 align-items-center" style={{ maxWidth: 400, width: "100%" }}>
                    <Form className="flex-grow-1">
                      <Form.Control
                        type="search"
                        placeholder="Start Typing to Search by Name or Phone..."
                        aria-label="Search"
                        value={userSearch}
                        onChange={e => {
                          setUserSearch(e.target.value);
                          setUserPage(0); // Reset to first page on new search
                        }}
                        ref={searchInputRef}
                      />
                    </Form>
                  </div>
                  {/* Pagination and results */}
                  {(() => {
                    const trimmedSearch = userSearch.trim();
                    const filteredResults = trimmedSearch.length > 0
                      ? userSearchResults
                        .filter(user =>
                          [
                            user.firstName,
                            user.lastName,
                            user.middleName,
                            user.phoneNumber
                          ]
                            .filter(Boolean)
                            .join(" ")
                            .toLowerCase()
                            .includes(trimmedSearch.toLowerCase())
                        )
                        .sort((a, b) => {
                          const last = a.lastName.localeCompare(b.lastName);
                          if (last !== 0) return last;
                          return a.firstName.localeCompare(b.firstName);
                        })
                      : [];

                    const pageSize = 8;
                    const pageCount = Math.ceil(filteredResults.length / pageSize);

                    return (
                      <>
                        {filteredResults.length > 0 && (
                          <div className='flex-column'
                            style={{
                              maxWidth: 400,
                              marginTop: '10px',
                              display: 'flex',
                              justifyContent: 'center'
                            }}>
                            <ul className="list-group flex-grow-1" style={{ maxWidth: 400, width: "100%" }}>
                              {filteredResults
                                .slice(userPage * pageSize, userPage * pageSize + pageSize)
                                .map((user, idx) => (
                                  <li
                                    key={user.userID || idx}
                                    className="list-group-item"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleUserSelect(user)}
                                  >
                                    <strong>
                                      {user.firstName} {user.middleName ? user.middleName + " " : ""}{user.lastName}
                                    </strong>
                                    &nbsp;
                                    <span className='opacity-50'>
                                      {user.phoneNumber && /^\d{10}$/.test(user.phoneNumber)
                                        ? `(${user.phoneNumber.substring(0, 3)}) ${user.phoneNumber.substring(3, 6)}-${user.phoneNumber.substring(6)}`
                                        : user.phoneNumber
                                      }
                                    </span>
                                    <br />
                                    Date of Birth: {user.DOB ? new Date(user.DOB).toLocaleDateString() : ""}
                                  </li>
                                ))}
                              {/* Add empty rows to fill up to 8 */}
                              {Array.from({ length: pageSize - Math.min(pageSize, filteredResults.length - userPage * pageSize) }).map((_, idx) => (
                                <li
                                  key={`empty-${idx}`}
                                  className="list-group-item"
                                  style={{
                                    height: 64.64,
                                    background: "transparent",
                                    border: "none",
                                    color: "transparent"
                                  }}
                                >
                                  {/* Empty placeholder */}
                                </li>
                              ))}
                            </ul>
                            <div className='flex-row pt-3' style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                              <Button
                                variant="primary"
                                size="sm"
                                disabled={userPage === 0}
                                onClick={() => setUserPage(userPage - 1)}
                              >
                                &lt;
                              </Button>
                              <Button
                                variant="primary"
                                size="sm"
                                disabled={userPage >= Math.ceil(
                                  userSearchResults
                                    .filter(user =>
                                      [
                                        user.firstName,
                                        user.lastName,
                                        user.middleName,
                                        user.phoneNumber
                                      ]
                                        .filter(Boolean)
                                        .join(" ")
                                        .toLowerCase()
                                        .includes(userSearch.toLowerCase())
                                    ).length / 8
                                ) - 1}
                                onClick={() => setUserPage(userPage + 1)}
                                className='px-3'
                              >
                                &gt;
                              </Button>
                            </div>
                          </div >
                        )}
                        {(filteredResults.length === 0 && trimmedSearch.length > 0) && (
                          <>
                            <div className="text-muted mt-3" style={{ fontSize: "1.6em", textAlign: "center", fontWeight: "500", height: 64.64 }}>
                              No results found.
                            </div>
                            <div
                              style={{
                                height: (64.64 * 7) + 46.28,
                                background: "transparent",
                                width: "100%"
                              }}
                            />
                          </>

                        )}
                        {/* Show 8 empty placeholders if no search input */}
                        {trimmedSearch.length === 0 && (
                          <div className='flex-column'
                            style={{
                              maxWidth: 400,
                              marginTop: '10px',
                              display: 'flex',
                              justifyContent: 'center'
                            }}>
                            <ul className="list-group flex-grow-1" style={{ maxWidth: 400, width: "100%" }}>
                              {[...Array(8)].map((_, idx) => (
                                <li
                                  key={`empty-${idx}`}
                                  className="list-group-item"
                                  style={{ height: 64.64 + 5.785, background: "transparent", border: "transparent" }}
                                >
                                  {/* Empty placeholder */}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              </Modal.Body>
            )}
            {showReleaseForm && (
              <Modal.Body>
                <div className="row g-4">
                  {/* Left column scan/manual entry form */}
                  <div className="col-md-6">
                    <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
                      <Button
                        id="add-manually-btn"
                        variant="primary"
                        onClick={() => setManualReleaseForm(!manualReleaseForm)}
                      >
                        {windowWidth > 1200 || windowWidth < 750 ? (
                          manualReleaseForm ? (
                            <>
                              <i className="bi bi-upc-scan me-2"></i>Back to Scan
                            </>
                          ) : (
                            <>
                              <i className="bi bi-pencil-square me-2"></i>Add Manually
                            </>
                          )
                        ) : (
                          manualReleaseForm ? (
                            <i className="bi bi-upc-scan"></i>
                          ) : (
                            <i className="bi bi-pencil-square"></i>
                          )
                        )}
                      </Button>
                      <div
                        id="release-user-btn"
                        className="bg-light border border-primary text-dark rounded-pill d-flex align-items-center py-2 px-3"

                        style={{ height: "38px", cursor: "pointer" }}
                        title="Click to change user"
                        onClick={() => {
                          setShowReleaseForm(false);
                          setShowIdentifyForm(true);
                          setManualIdentifyForm(true);
                        }}
                      >
                        <i className="bi bi-person-circle me-2"></i>
                        <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ width: "100%" }}>
                          <span style={{ fontWeight: "bold", fontSize: "1.15em", lineHeight: 1 }}>
                            {selectedUser
                              ? `${selectedUser.firstName} ${selectedUser.lastName}`
                              : ""}
                          </span>
                          {/* {selectedUser && selectedUser.phoneNumber && (
                        <span className="text-muted" style={{ fontSize: "1em", lineHeight: 1, marginLeft: 8 }}>
                          {formatPhone(selectedUser.phoneNumber)}
                        </span>
                      )} */}
                        </div>
                        <i className="bi bi-pencil ms-2 text-primary"></i>
                      </div>
                    </div>
                    {/* Manual entry form for adding items to preview */}
                    {manualReleaseForm && (
                      <form onSubmit={handleManualSubmit}>
                        <div id="manual-form-fields">
                          <div className="row g-2">
                            {/* Item name input with suggestions */}
                            <div className="col-md-6 position-relative form-floating">
                              <Select
                                classNamePrefix="react-select"
                                className="form-floating"
                                placeholder="Item Name"
                                name="itemName"
                                value={
                                  itemNameInput
                                    ? { value: itemNameInput, label: itemNameInput }
                                    : null
                                }
                                onChange={option => {
                                  setItemNameInput(option ? option.value : "");
                                  setVariationNameInput("");
                                  setVariationSuggestions([]);
                                }}
                                options={allItems.map(item => ({
                                  value: item.name,
                                  label: item.name
                                }))}
                                isSearchable
                                isClearable
                                required={!codeInput}
                                ref={itemNameInputRef}
                                styles={{
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    paddingLeft: 0 // Remove left padding
                                  })
                                }}
                              />
                            </div>
                            {/* Variation name input with suggestions */}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                !itemNameInput ? (
                                  <Tooltip id="variation-tooltip">
                                    Select an item first
                                  </Tooltip>
                                ) : <></>
                              }
                            >
                              <div className="col-md-6 position-relative form-floating">
                                <Select
                                  classNamePrefix="react-select"
                                  className="form-floating"
                                  placeholder="Variation Name"
                                  name="variationName"
                                  value={
                                    variationNameInput
                                      ? { value: variationNameInput, label: variationNameInput }
                                      : null
                                  }
                                  onChange={option => {
                                    setVariationNameInput(option ? option.value : "");
                                    setVariationSuggestions([]);
                                    // Autofill code if available
                                    if (option) {
                                      const selectedItem = allItems.find(item => item.name === itemNameInput);
                                      const selectedVariation = allVariations.find(
                                        v => v.name === option.value && selectedItem && v.itemID === selectedItem.itemID
                                      );
                                      if (selectedVariation) {
                                        if (selectedVariation.upc && selectedVariation.upc.trim() !== "") {
                                          setCodeInput(selectedVariation.upc);
                                        } else if (selectedVariation.plu && selectedVariation.plu.trim() !== "") {
                                          setCodeInput(selectedVariation.plu);
                                        } else if (selectedVariation.otherCode && selectedVariation.otherCode.trim() !== "") {
                                          setCodeInput(selectedVariation.otherCode);
                                        }
                                      }
                                    }
                                  }}
                                  options={
                                    (() => {
                                      const selectedItem = allItems.find(item => item.name === itemNameInput);
                                      let filteredVariations = allVariations;
                                      if (selectedItem) {
                                        filteredVariations = allVariations.filter(
                                          variation => variation.itemID === selectedItem.itemID
                                        );
                                      }
                                      return filteredVariations.map(variation => ({
                                        value: variation.name,
                                        label: variation.name
                                      }));
                                    })()
                                  }
                                  isSearchable
                                  isClearable
                                  required={!codeInput}
                                  isDisabled={!itemNameInput}
                                  styles={{
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      paddingLeft: 0 // Remove left padding
                                    })
                                  }}
                                />
                              </div>
                            </OverlayTrigger>
                          </div>
                          <div className="row g-2">
                            {/* Quantity input for release */}
                            <div className="col-md-6 form-floating">
                              <input
                                type="number"
                                placeholder="Release Quantity"
                                className="form-control my-1"
                                name="quantity"
                                value={quantityInput}
                                onChange={e => setQuantityInput(e.target.value)}
                                required
                                min={1}
                              />
                              <label htmlFor="text" className="form-label">
                                Release Quantity
                              </label>
                            </div>
                            {/* Unified code input */}
                            <div className="col-md-6 form-floating">
                              <input
                                id="release-code-input"
                                type="text"
                                className="form-control my-1"
                                name="code"
                                value={codeInput}
                                onChange={e => setCodeInput(e.target.value.replace(/\D/g, ""))}
                                maxLength={12}
                                inputMode="numeric"
                                required={!(itemNameInput && variationNameInput)}
                                placeholder="Enter UPC/PLU/Other code"
                                pattern="\d{4,12}"
                                ref={codeInputRef}
                              />
                              <label htmlFor="text" className="form-label">
                                Code
                              </label>
                            </div>
                          </div>

                          {/* Add/Update button for preview list */}
                          <div className="d-flex justify-content-end my-3">
                            <Button id="add-item-btn" type="submit" variant="danger">
                              {editIndex !== null ? "Update" : "Add"}
                            </Button>
                          </div>
                        </div>
                      </form>
                    )}
                    {/* Scan mode for quick code entry */}
                    {!manualReleaseForm && (
                      <>
                        <div className="d-flex align-items-center justify-content-center py-5 gap-3">
                          <i className="bi bi-upc-scan fs-2"></i>
                          <h4 className="mb-0">Scan or enter code...</h4>
                        </div>
                        <div className="d-flex align-items-center my-3 gap-2" id="release-code-input">
                          <input
                            type="text"
                            inputMode="numeric"
                            className="form-control"
                            placeholder="Scan or enter UPC/PLU/Other code"
                            ref={codeInputRef}
                            value={scanCode}
                            onChange={handleScan}
                            onKeyDown={handleScanKeyDown}
                            maxLength={12}
                            min={"0"}
                            style={{ flex: 1 }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {/* Right column preview list of items to be released */}
                  <div className="col-md-6 pb-3 d-flex flex-column">
                    <div className="card m-0 bg-light flex-grow-1 d-flex flex-column">
                      {addedItems.length === 0 ? (
                        <div className="flex-grow-1 d-flex justify-content-center align-items-center text-muted" id="preview-table">
                          No items added yet
                        </div>
                      ) : (
                        <div className="table-responsive flex-grow-1">
                          <table className="table table-sm table-bordered">
                            <thead className="table-light">
                              <tr>
                                <th>Name/Variation</th>
                                <th>Qty</th>
                                <th>Unit</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {addedItems.map((item, index) => (
                                <tr key={index} id={index === 0 ? 'preview-item-0' : undefined}>
                                  <td>
                                    <div style={{ fontWeight: 'bold' }}>{item.variationName}</div>
                                    <div style={{ fontSize: 'smaller', color: '#666' }}>{item.itemName}</div>
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      min={1}
                                      max={item.totalAvailable}
                                      value={item.quantity}
                                      onChange={e => {
                                        const valStr = e.target.value;
                                        const val = parseInt(valStr, 10);
                                        if (isNaN(val) || valStr.trim() === "") {
                                          showReceiveItemSuccessBanner(
                                            "Invalid Quantity",
                                            <span>Please enter a valid number for quantity.</span>,
                                            "alert"
                                          );
                                          return;
                                        }
                                        if (val < 1) {
                                          showReceiveItemSuccessBanner(
                                            "Invalid Quantity",
                                            <span>Quantity must be at least 1.</span>,
                                            "alert"
                                          );
                                          return;
                                        }
                                        if (val > item.totalAvailable) {
                                          showReceiveItemSuccessBanner(
                                            "Quantity Exceeded",
                                            <span>Cannot exceed available quantity ({item.totalAvailable})</span>,
                                            "alert"
                                          );
                                          return;
                                        }
                                        const updated = [...addedItems];
                                        updated[index].quantity = val;
                                        setAddedItems(updated);
                                      }}
                                      style={{ width: 50, textAlign: "center" }}
                                    />
                                  </td>
                                  <td>{item.unitQty}</td>
                                  <td className="text-center align-middle" style={{ verticalAlign: "middle" }}>
                                    <Button
                                      variant="danger"
                                      size="sm"
                                      className="rounded-circle d-flex align-items-center justify-content-center mx-auto"
                                      style={{ width: 32, height: 32, padding: 0 }}
                                      onClick={() => removeItem(index)}
                                      title="Remove from list"
                                    >
                                      <i className="bi bi-trash" style={{ fontSize: "1.2rem", margin: "0 auto" }}></i>
                                      <span className="visually-hidden">Remove</span>
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                    {/* Finalize button to submit all released items */}
                    {addedItems.length > 0 && (
                      <div className="d-flex flex-row flex-md-row gap-3 mt-3 align-items-end">
                        <div className="form-group flex-grow-1 me-3" id="transactionType">
                          <label htmlFor="transactionType" className="form-label mb-2">
                            Transaction Type
                          </label>
                          <select

                            className="form-select"
                            value={transactionType}
                            onChange={e => setTransactionType(e.target.value)}
                            style={{ minHeight: "48px", fontSize: "1.1rem" }}
                            required
                          >
                            <option value="DISTRIBUTION">Distribution</option>
                            <option value="DAMAGES">Damages</option>
                            <option value="EXPIRY">Expiry</option>
                            <option value="OTHER">Other</option>
                          </select>
                        </div>
                        {/* Finalize button */}
                        <Button
                          id="finalize-btn"
                          variant="success"
                          onClick={finalizeRelease}
                          style={{
                            height: "48px",
                            fontSize: "1.1rem",
                            marginBottom: "16px",
                            marginLeft: "16px"
                          }}
                        >
                          Finalize
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </Modal.Body>
            )}
          </>
        )}
      </div>
    </Modal >
  );
}
